import { RuntimeScene } from '@easytwin/runtime';
import { useBindSignal } from './useBindSignal';
import { useDumbState } from './useDumbState';

export function useSceneCamera(scene: RuntimeScene | undefined) {
  const refresh = useDumbState();
  const sceneCamera = scene?.camera._sceneCamera;
  useBindSignal(sceneCamera?.onCameraModeChanged, refresh);
  return sceneCamera;
}
